import React, { Fragment, useEffect, useState } from "react";
import List from "@mui/material/List";
import Checkbox from "@mui/material/Checkbox";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { Autocomplete, TextField, Button } from "@mui/material";
import { Box } from "react-feather";
import { Col, Row } from "reactstrap";

import axios from "axios";

const useStyles = makeStyles((theme) => ({
  listHeight: {
    height: "calc(100vh - 100px - 317px)",
    maxHeight: "calc(100vh - 100px - 317px)",
    overflow: "auto",
    "@media screen and (max-width: 767px)": {
      height: "calc(100vh - 100px - 180px)",
      maxHeight: "calc(100vh - 100px - 180px)",
    },
  },
  listHeightError: {
    height: "calc(100vh - 100px - 256px)",
    maxHeight: "calc(100vh - 100px - 256px)",
    overflow: "auto",
    "@media screen and (max-width: 767px)": {
      height: "calc(100vh - 100px - 239px)",
      maxHeight: "calc(100vh - 100px - 239px)",
    },
  },
}));
const InterestSelection = (props) => {
  const { setSelected, selected } = props;
  const isCategoryMode = props?.selectionMode === "category";
  const [filterText, setFilterText] = useState("");
  const [selectedPositions, setSelectedPositions] = useState(
    Array.isArray(selected) ? selected : []
  );
  const [positionList, setPositionList] = useState(props.options);
  const makeInputId = (value, index) =>
    `interest-${String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")}-${index}`;

  const toggleSelection = (value) => {
    const selectedItems = Array.isArray(selectedPositions)
      ? [...selectedPositions]
      : [];
    const exists = selectedItems.some((d) => d === value);
    const nextSelected = exists
      ? selectedItems.filter((d) => d !== value)
      : [...selectedItems, value];

    setSelectedPositions(nextSelected);
    setSelected(nextSelected);
  };

  useEffect(() => {
    setSelectedPositions(Array.isArray(selected) ? selected : []); // Sync when props.selected updates
  }, [selected]);
  useEffect(() => {
    setPositionList(props.options || []);
  }, [props.options]);

  return (
    <div className="  w-full flex-col">
      <Typography className="flex w-full justify-center py-8 bg-gray-200 text-gray-600 text-18">
        {`Search / Select ${props.labelName}  `}
      </Typography>

      <TextField
        margin="dense"
        className="flex w-full "
        style={{ width: "100%" }}
        variant="outlined"
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            color: "black",
            paddingTop: "12px",
          },
        }}
        label={`Search ${props.labelName} `}
        onChange={(e) => {
          setFilterText(e.target.value);
        }}
      />
      <div
        style={{
          height: "150px",
          width: "100%",
          overflowX: "auto",
          border: "1px solid #d2d2d2",
          borderRadius: "5px",
          padding: "5px 5px",
        }}
      >
        <div
          className="d-flex align-content-start flex-wrap"
          style={{ position: "relative" }}
        >
          {positionList
            .filter((item) => {
              return selectedPositions.find((d) => d == item.value) != null;
            })
            .map((i, index) => {
              const inputId = isCategoryMode
                ? makeInputId(i.value, index)
                : String(i.value || "");
              return (
                <div className="p-1" key={`selected-${String(i.value)}-${index}`}>
                  <input
                    type="checkbox"
                    className="btn-check font-primary"
                    value={i.value}
                    tabIndex={-1}
                    name="positionList"
                    id={inputId}
                    onChange={() => toggleSelection(i.value)}
                    checked={
                      selectedPositions.find((d) => d === i.value) != null
                    }
                    autoComplete="off"
                  />
                  <label
                    className="btn btn-outline-primary chipbtnchecked"
                    htmlFor={inputId}
                  >
                    {i.label}
                  </label>
                </div>
              );
            })}
          {positionList
            .filter((item) => {
              return (
                selectedPositions.find((d) => d === item.value) == null &&
                item.label
                  .toLowerCase()
                  .indexOf(filterText.toLocaleLowerCase()) > -1
              );
            })
            .map((i, index) => {
              const inputId = isCategoryMode
                ? makeInputId(i.value, index + 100000)
                : String(i.value || "");
              return (
                <div className="p-1" key={`available-${String(i.value)}-${index}`}>
                  <input
                    type="checkbox"
                    className="btn-check font-primary"
                    value={i.value}
                    tabIndex={-1}
                    name="positionList"
                    id={inputId}
                    onChange={() => toggleSelection(i.value)}
                    checked={
                      selectedPositions.find((d) => d === i.value) != null
                    }
                    autoComplete="off"
                  />
                  <label
                    className="btn btn-outline-primary chipbtn"
                    htmlFor={inputId}
                  >
                    {i.label}
                  </label>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default InterestSelection;
